import { c as _c } from "react-compiler-runtime";
import { useState, useMemo, useRef, useEffect } from 'react';
import { Provider } from 'react-redux';
import { createStore } from '../../redux/createStore';
import { StoreContext } from '../../redux/storeContext';
import { createWidthsStore } from '../../redux/createWidthsStore';
import { createSelectionStore } from '../../redux/createSelectionStore';
import { WidthsStoreContext } from '../../redux/widthsStoreContext';
import { SelectionStoreContext } from '../../redux/selectionStoreContext';
import { EmptyComponent } from '../utils/EmptyComponent';
import { DEFAULT_PAGE_SIZES } from '../../pagination/constants/pageSizes';
import emptyFunction from 'react-utils/emptyFunction';
import Table from './Table';
import { ProvideAuth } from '../../auth/context/AuthContext';
import { DEFAULT_COLUMN_MINIMUM_WIDTH, DEFAULT_COLUMN_WIDTH, MINIMUM_RESIZABLE_COLUMN_WIDTH } from '../constants/sizes';
import { DefaultRowComponent } from './DefaultRowComponent';
import { DefaultTableComponent } from './DefaultTableComponent';
import { ProvideLogger } from '../../logger/context/LoggerContext';
import { ProvideFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { ProvideColumnCallToAction } from '../columnCallToAction/ColumnCallToActionContext';
import { useResolvedColumnCallToAction } from '../columnCallToAction/useResolvedColumnCallToAction';
import DefaultSelectAllComponent from '../../selection/components/DefaultSelectAllComponent';
import { ProvideVirtualization } from '../../virtualization/VirtualizationContext';
import { useAdjustCtaColumnWidth } from '../columnCallToAction/useAdjustCtaColumnWidth';
import { getColumnKey } from '../utils/getColumnKey';
import Raven from 'raven-js';
import { BulkActionsContainerAboveTable } from './BulkActionsContainerAboveTable';
import { infiniteScrollDisabled } from '../../infiniteScroll/config';
import { rightToolbarDisabled } from '../../rightToolbar/config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const emptyArray = [];
const DEFAULT_NAMESPACE = 'DEFAULT_NAMESPACE';

//we explicitly prevent a column width of 0 - this || is weight bearing over ??
const getMinimumColumnWidth = column => Math.max(column.minimumColumnWidth || DEFAULT_COLUMN_MINIMUM_WIDTH,
// Below MINIMUM_RESIZABLE_COLUMN_WIDTH, users can no longer interact with column resizing and can get stuck with a too-narrow column
column.resizable ? MINIMUM_RESIZABLE_COLUMN_WIDTH : 0);
const TableWrapper = t0 => {
  const $ = _c(105);
  const {
    alternateHeaderLeftSlot: t1,
    BulkActionsComponent: t2,
    canSelectAllRecords: t3,
    columns,
    CustomSelectAllComponent: t4,
    disableScrollReset: t5,
    getRowId,
    hasGate,
    hasScope,
    headerLeftSlot: t6,
    headerRightSlot: t7,
    infiniteScrollConfig: t8,
    isBulkActionsRedesignEnabled: t9,
    isIndexRedesignEnabled: t10,
    loading: t11,
    logger: t12,
    noRowsSlot: t13,
    numberOfFrozenColumns: t14,
    onColumnOrderChange: t15,
    onColumnWidthChange: t16,
    contextMenuConfig,
    columnCallToAction,
    onPageIndexChange: t17,
    onPageSizeChange: t18,
    onSortsChange: t19,
    pageable: t20,
    pageIndex: t21,
    pageSize: t22,
    pageSizes: t23,
    paginatorAlignment: t24,
    reorderable: t25,
    resizable: t26,
    rows,
    RowComponent: t27,
    scrollContainerRef,
    selectable: t28,
    selectionStore: externalSelectionStore,
    sortable: t29,
    sorts: t30,
    TableComponent: t31,
    totalRowCount: t32,
    zebraStripe: t33,
    condensed: t34,
    dataDensity,
    enableFullVirtualization: t35,
    onFrozenColumnWidthAlert,
    hasTopBarBorderRadius,
    rightToolbarConfig: t36
  } = t0;
  const alternateHeaderLeftSlot = t1 === undefined ? null : t1;
  const BulkActionsComponent = t2 === undefined ? EmptyComponent : t2;
  const canSelectAllRecords = t3 === undefined ? true : t3;
  const CustomSelectAllComponent = t4 === undefined ? DefaultSelectAllComponent : t4;
  const disableScrollReset = t5 === undefined ? false : t5;
  const headerLeftSlot = t6 === undefined ? null : t6;
  const headerRightSlot = t7 === undefined ? null : t7;
  const infiniteScrollConfig = t8 === undefined ? infiniteScrollDisabled : t8;
  const isBulkActionsRedesignEnabled = t9 === undefined ? false : t9;
  const isIndexRedesignEnabled = t10 === undefined ? false : t10;
  const loading = t11 === undefined ? false : t11;
  const logger = t12 === undefined ? emptyFunction : t12;
  const noRowsSlot = t13 === undefined ? null : t13;
  const numberOfFrozenColumns = t14 === undefined ? 0 : t14;
  const onColumnOrderChange = t15 === undefined ? emptyFunction : t15;
  const onColumnWidthChange = t16 === undefined ? emptyFunction : t16;
  const onPageIndexChange = t17 === undefined ? emptyFunction : t17;
  const onPageSizeChange = t18 === undefined ? emptyFunction : t18;
  const onSortsChange = t19 === undefined ? emptyFunction : t19;
  const pageable = t20 === undefined ? true : t20;
  const pageIndex = t21 === undefined ? 0 : t21;
  const pageSize = t22 === undefined ? DEFAULT_PAGE_SIZES[0] : t22;
  const pageSizes = t23 === undefined ? DEFAULT_PAGE_SIZES : t23;
  const paginatorAlignment = t24 === undefined ? "center" : t24;
  const reorderable = t25 === undefined ? true : t25;
  const resizable = t26 === undefined ? true : t26;
  const RowComponent = t27 === undefined ? DefaultRowComponent : t27;
  const selectable = t28 === undefined ? true : t28;
  const sortable = t29 === undefined ? true : t29;
  const sorts = t30 === undefined ? emptyArray : t30;
  const TableComponent = t31 === undefined ? DefaultTableComponent : t31;
  const totalRowCount = t32 === undefined ? 0 : t32;
  const zebraStripe = t33 === undefined ? false : t33;
  const condensed = t34 === undefined ? true : t34;
  const enableFullVirtualization = t35 === undefined ? false : t35;
  const rightToolbarConfig = t36 === undefined ? rightToolbarDisabled : t36;
  const alreadyLoggedRavenRef = useRef(false);
  let t37;
  if ($[0] !== columns || $[1] !== reorderable || $[2] !== resizable || $[3] !== sortable) {
    let t38;
    if ($[5] !== reorderable || $[6] !== resizable || $[7] !== sortable) {
      t38 = column => {
        const minimumColumnWidth = getMinimumColumnWidth(column);
        const width = Math.max(column.width || DEFAULT_COLUMN_WIDTH, minimumColumnWidth);
        return Object.assign({}, column, {
          columnNamespace: column.columnNamespace || DEFAULT_NAMESPACE,
          width,
          minimumColumnWidth,
          resizable: column.resizable != null ? column.resizable : resizable,
          reorderable: column.reorderable != null ? column.reorderable : reorderable,
          sortable: column.sortable != null ? column.sortable : sortable
        });
      };
      $[5] = reorderable;
      $[6] = resizable;
      $[7] = sortable;
      $[8] = t38;
    } else {
      t38 = $[8];
    }
    t37 = columns.map(t38);
    $[0] = columns;
    $[1] = reorderable;
    $[2] = resizable;
    $[3] = sortable;
    $[4] = t37;
  } else {
    t37 = $[4];
  }
  const columnsWithDefaults = t37;
  let t38;
  let t39;
  if ($[9] !== columns) {
    t38 = () => {
      for (const column_0 of columns) {
        const minimumColumnWidth_0 = getMinimumColumnWidth(column_0);
        if (column_0.width && column_0.width < minimumColumnWidth_0) {
          const errorExtra = {
            columnName: column_0.columnName,
            columnNamespace: column_0.columnNamespace,
            width: column_0.width,
            minimumColumnWidth: minimumColumnWidth_0
          };
          console.error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users.", errorExtra);
          if (!alreadyLoggedRavenRef.current) {
            Raven.captureException(new Error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users."), {
              extra: {
                errorExtra
              }
            });
            alreadyLoggedRavenRef.current = true;
          }
        }
      }
    };
    t39 = [columns];
    $[9] = columns;
    $[10] = t38;
    $[11] = t39;
  } else {
    t38 = $[10];
    t39 = $[11];
  }
  useEffect(t38, t39);
  let t40;
  if ($[12] !== columnsWithDefaults) {
    t40 = () => createWidthsStore({
      initialWidths: columnsWithDefaults.reduce(_temp, {})
    });
    $[12] = columnsWithDefaults;
    $[13] = t40;
  } else {
    t40 = $[13];
  }
  const [widthsStore] = useState(t40);
  let t41;
  if ($[14] !== columnCallToAction || $[15] !== columnsWithDefaults || $[16] !== widthsStore) {
    t41 = {
      columnCallToAction,
      columnsWithDefaults,
      widthsStore
    };
    $[14] = columnCallToAction;
    $[15] = columnsWithDefaults;
    $[16] = widthsStore;
    $[17] = t41;
  } else {
    t41 = $[17];
  }
  useAdjustCtaColumnWidth(t41);
  let t42;
  if ($[18] !== externalSelectionStore) {
    t42 = () => externalSelectionStore ? null : createSelectionStore();
    $[18] = externalSelectionStore;
    $[19] = t42;
  } else {
    t42 = $[19];
  }
  const [internalSelectionStore] = useState(t42);
  const selectionStore = externalSelectionStore !== null && externalSelectionStore !== void 0 ? externalSelectionStore : internalSelectionStore;
  const [store] = useState(_temp2);
  let t43;
  if ($[20] !== sorts) {
    t43 = sorts.map(_temp3);
    $[20] = sorts;
    $[21] = t43;
  } else {
    t43 = $[21];
  }
  const sortsWithDefaults = t43;
  const shouldShowBulkActionsContainerAboveTable = isBulkActionsRedesignEnabled && isIndexRedesignEnabled;
  let t44;
  if ($[22] !== columnCallToAction || $[23] !== columnsWithDefaults || $[24] !== numberOfFrozenColumns || $[25] !== rows) {
    t44 = {
      columnCallToAction,
      columnsWithDefaults,
      rows,
      numberOfFrozenColumns
    };
    $[22] = columnCallToAction;
    $[23] = columnsWithDefaults;
    $[24] = numberOfFrozenColumns;
    $[25] = rows;
    $[26] = t44;
  } else {
    t44 = $[26];
  }
  const resolvedColumnCallToAction = useResolvedColumnCallToAction(t44);
  let t45;
  if ($[27] !== BulkActionsComponent || $[28] !== canSelectAllRecords || $[29] !== getRowId || $[30] !== isBulkActionsRedesignEnabled || $[31] !== isIndexRedesignEnabled || $[32] !== rows || $[33] !== shouldShowBulkActionsContainerAboveTable || $[34] !== totalRowCount) {
    t45 = shouldShowBulkActionsContainerAboveTable && /*#__PURE__*/_jsx(BulkActionsContainerAboveTable, {
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      getRowId: getRowId,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      rows: rows,
      totalRowCount: totalRowCount
    });
    $[27] = BulkActionsComponent;
    $[28] = canSelectAllRecords;
    $[29] = getRowId;
    $[30] = isBulkActionsRedesignEnabled;
    $[31] = isIndexRedesignEnabled;
    $[32] = rows;
    $[33] = shouldShowBulkActionsContainerAboveTable;
    $[34] = totalRowCount;
    $[35] = t45;
  } else {
    t45 = $[35];
  }
  let t46;
  if ($[36] !== BulkActionsComponent || $[37] !== CustomSelectAllComponent || $[38] !== RowComponent || $[39] !== TableComponent || $[40] !== alternateHeaderLeftSlot || $[41] !== canSelectAllRecords || $[42] !== columnsWithDefaults || $[43] !== condensed || $[44] !== dataDensity || $[45] !== disableScrollReset || $[46] !== enableFullVirtualization || $[47] !== getRowId || $[48] !== hasTopBarBorderRadius || $[49] !== headerLeftSlot || $[50] !== headerRightSlot || $[51] !== infiniteScrollConfig || $[52] !== isBulkActionsRedesignEnabled || $[53] !== isIndexRedesignEnabled || $[54] !== loading || $[55] !== noRowsSlot || $[56] !== numberOfFrozenColumns || $[57] !== onColumnOrderChange || $[58] !== onColumnWidthChange || $[59] !== onFrozenColumnWidthAlert || $[60] !== onPageIndexChange || $[61] !== onPageSizeChange || $[62] !== onSortsChange || $[63] !== pageIndex || $[64] !== pageSize || $[65] !== pageSizes || $[66] !== pageable || $[67] !== paginatorAlignment || $[68] !== reorderable || $[69] !== resizable || $[70] !== rightToolbarConfig || $[71] !== rows || $[72] !== scrollContainerRef || $[73] !== selectable || $[74] !== sortable || $[75] !== sortsWithDefaults || $[76] !== totalRowCount || $[77] !== zebraStripe) {
    t46 = /*#__PURE__*/_jsx(Table, {
      alternateHeaderLeftSlot: alternateHeaderLeftSlot,
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      scrollContainerRef: scrollContainerRef,
      columns: columnsWithDefaults,
      condensed: condensed,
      dataDensity: dataDensity,
      CustomSelectAllComponent: CustomSelectAllComponent,
      disableScrollReset: disableScrollReset,
      enableFullVirtualization: enableFullVirtualization,
      getRowId: getRowId,
      headerLeftSlot: headerLeftSlot,
      headerRightSlot: headerRightSlot,
      infiniteScrollConfig: infiniteScrollConfig,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      loading: loading,
      noRowsSlot: noRowsSlot,
      numberOfFrozenColumns: numberOfFrozenColumns,
      onColumnOrderChange: onColumnOrderChange,
      onColumnWidthChange: onColumnWidthChange,
      onFrozenColumnWidthAlert: onFrozenColumnWidthAlert,
      onPageIndexChange: onPageIndexChange,
      onPageSizeChange: onPageSizeChange,
      onSortsChange: onSortsChange,
      pageable: pageable,
      pageIndex: pageIndex,
      pageSize: pageSize,
      pageSizes: pageSizes,
      paginatorAlignment: paginatorAlignment,
      reorderable: reorderable,
      resizable: resizable,
      RowComponent: RowComponent,
      rows: rows,
      selectable: selectable,
      sorts: sortsWithDefaults,
      sortable: sortable,
      TableComponent: TableComponent,
      totalRowCount: totalRowCount,
      zebraStripe: zebraStripe,
      hasTopBarBorderRadius: hasTopBarBorderRadius,
      rightToolbarConfig: rightToolbarConfig
    });
    $[36] = BulkActionsComponent;
    $[37] = CustomSelectAllComponent;
    $[38] = RowComponent;
    $[39] = TableComponent;
    $[40] = alternateHeaderLeftSlot;
    $[41] = canSelectAllRecords;
    $[42] = columnsWithDefaults;
    $[43] = condensed;
    $[44] = dataDensity;
    $[45] = disableScrollReset;
    $[46] = enableFullVirtualization;
    $[47] = getRowId;
    $[48] = hasTopBarBorderRadius;
    $[49] = headerLeftSlot;
    $[50] = headerRightSlot;
    $[51] = infiniteScrollConfig;
    $[52] = isBulkActionsRedesignEnabled;
    $[53] = isIndexRedesignEnabled;
    $[54] = loading;
    $[55] = noRowsSlot;
    $[56] = numberOfFrozenColumns;
    $[57] = onColumnOrderChange;
    $[58] = onColumnWidthChange;
    $[59] = onFrozenColumnWidthAlert;
    $[60] = onPageIndexChange;
    $[61] = onPageSizeChange;
    $[62] = onSortsChange;
    $[63] = pageIndex;
    $[64] = pageSize;
    $[65] = pageSizes;
    $[66] = pageable;
    $[67] = paginatorAlignment;
    $[68] = reorderable;
    $[69] = resizable;
    $[70] = rightToolbarConfig;
    $[71] = rows;
    $[72] = scrollContainerRef;
    $[73] = selectable;
    $[74] = sortable;
    $[75] = sortsWithDefaults;
    $[76] = totalRowCount;
    $[77] = zebraStripe;
    $[78] = t46;
  } else {
    t46 = $[78];
  }
  let t47;
  if ($[79] !== store || $[80] !== t45 || $[81] !== t46) {
    t47 = /*#__PURE__*/_jsxs(Provider, {
      store: store,
      context: StoreContext,
      children: [t45, t46]
    });
    $[79] = store;
    $[80] = t45;
    $[81] = t46;
    $[82] = t47;
  } else {
    t47 = $[82];
  }
  let t48;
  if ($[83] !== selectionStore || $[84] !== t47) {
    t48 = /*#__PURE__*/_jsx(Provider, {
      store: selectionStore,
      context: SelectionStoreContext,
      children: t47
    });
    $[83] = selectionStore;
    $[84] = t47;
    $[85] = t48;
  } else {
    t48 = $[85];
  }
  let t49;
  if ($[86] !== t48 || $[87] !== widthsStore) {
    t49 = /*#__PURE__*/_jsx(Provider, {
      store: widthsStore,
      context: WidthsStoreContext,
      children: t48
    });
    $[86] = t48;
    $[87] = widthsStore;
    $[88] = t49;
  } else {
    t49 = $[88];
  }
  let t50;
  if ($[89] !== resolvedColumnCallToAction || $[90] !== t49) {
    t50 = /*#__PURE__*/_jsx(ProvideColumnCallToAction, {
      value: resolvedColumnCallToAction,
      children: t49
    });
    $[89] = resolvedColumnCallToAction;
    $[90] = t49;
    $[91] = t50;
  } else {
    t50 = $[91];
  }
  let t51;
  if ($[92] !== contextMenuConfig || $[93] !== t50) {
    t51 = /*#__PURE__*/_jsx(ProvideFDTContextMenuConfig, {
      contextMenuConfig: contextMenuConfig,
      children: t50
    });
    $[92] = contextMenuConfig;
    $[93] = t50;
    $[94] = t51;
  } else {
    t51 = $[94];
  }
  let t52;
  if ($[95] !== enableFullVirtualization || $[96] !== t51) {
    t52 = /*#__PURE__*/_jsx(ProvideVirtualization, {
      enableFullVirtualization: enableFullVirtualization,
      children: t51
    });
    $[95] = enableFullVirtualization;
    $[96] = t51;
    $[97] = t52;
  } else {
    t52 = $[97];
  }
  let t53;
  if ($[98] !== logger || $[99] !== t52) {
    t53 = /*#__PURE__*/_jsx(ProvideLogger, {
      logger: logger,
      children: t52
    });
    $[98] = logger;
    $[99] = t52;
    $[100] = t53;
  } else {
    t53 = $[100];
  }
  let t54;
  if ($[101] !== hasGate || $[102] !== hasScope || $[103] !== t53) {
    t54 = /*#__PURE__*/_jsx(ProvideAuth, {
      hasScope: hasScope,
      hasGate: hasGate,
      children: t53
    });
    $[101] = hasGate;
    $[102] = hasScope;
    $[103] = t53;
    $[104] = t54;
  } else {
    t54 = $[104];
  }
  return t54;
};
export default TableWrapper;
function _temp(acc, column_1) {
  const width_0 = column_1.width || DEFAULT_COLUMN_WIDTH;
  acc[getColumnKey(column_1.columnNamespace || DEFAULT_NAMESPACE, column_1.columnName)] = width_0;
  return acc;
}
function _temp2() {
  return createStore();
}
function _temp3(sort) {
  return Object.assign({}, sort, {
    columnNamespace: sort.columnNamespace != null ? sort.columnNamespace : DEFAULT_NAMESPACE
  });
}